import {useLocale} from "@components/Contexts/LocaleContext"
import Typography, {Size} from "@components/WebsiteRevamp/Typography/Typography"

import styles from "./FooterBottom.module.scss"

type Props = {}

const FooterBottom = (props: Props): any => {
	const {locale} = useLocale()

	const year = new Date().getFullYear()
	const currentLanguage = (locale || "en").split("-")[0]

	const copyrightNoticeOptions: Record<string, string> = {
		// add more later
		en: `One Communications Ltd. | Copyright ${year} | Keilalahdentie 2-4 FI-02150 Espoo Finland`,
		fi: `One Communications Oy | © ${year} | Keilalahdentie 2-4 02150 Espoo`,
		se: `One Communications Ltd. | © ${year} | Keilalahdentie 2-4 02150 Espoo Finland`,
		da: `One Communications Ltd. | © ${year} | Keilalahdentie 2-4 02150 Espoo Finland`,
	}

	const copyrightNotice =
		copyrightNoticeOptions[currentLanguage] ?? copyrightNoticeOptions.en

	return (
		<Typography
			className={styles.container}
			content={copyrightNotice}
			fontWeight={300}
			size={Size.XXS}
		/>
	)
}

export default FooterBottom
